export default __webpack_public_path__ + "static/media/facebook.3f5bc70d.svg";